module.exports = __webpack_public_path__ + "images/emoji/izakaya_lantern.1e509a4ee942ea01f20a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/izakaya_lantern.png
// module id = tnrO
// module chunks = 13